import { Paragraph } from '@/components/common/Typography';
import { DepositoryAccountSelector } from '@/components/financialEntities/DepositoryAccountSelectionView';
import { useCheckDepositoryAccount } from '@/components/financialEntities/helpers';
import { assert } from '@common/errors';
import { useState } from 'react';
import { labelByIraType } from './helpers';
import { useOpenIraFlowContext } from './OpenIraFlow';
import OpenIraFlowStep from './OpenIraFlowStep';

const OpenIraFlowFundingStep = () => {
    const { setStep, iraType, info, updateInfo } = useOpenIraFlowContext();
    assert(info);
    const [fundingAccountId, setFundingAccountId] = useState<
        string | undefined
    >(info.fundingAccountId);
    const { checkDepositoryAccount, errorMessageByAccountId } =
        useCheckDepositoryAccount({
            setSelectedAccountId: setFundingAccountId,
        });
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
        <OpenIraFlowStep
            headerTitle={`You’re nearly done, choose a bank account to fund your ${labelByIraType[iraType]} IRA`}
            onBack={() => setStep('PLAN')}
            onNext={async () => {
                assert(fundingAccountId);
                if (isSubmitting) return;
                setIsSubmitting(true);
                try {
                    await checkDepositoryAccount(fundingAccountId);
                    await updateInfo({
                        ...info,
                        fundingAccountId,
                        lastCompletedRetirementStep: 'FUNDING',
                    });
                    setStep('REVIEW');
                } catch {
                    // do nothing; allow checkDepositoryAccount to handle errors
                } finally {
                    setIsSubmitting(false);
                }
            }}
            isSubmitting={isSubmitting}
            isNextDisabled={!fundingAccountId}
        >
            <Paragraph textColor="textMuted" mb={12}>
                {`You can change or stop funding your ${labelByIraType[iraType]} IRA at anytime.`}
            </Paragraph>
            <DepositoryAccountSelector
                selectedAccountId={fundingAccountId}
                onChangeSelectedAccountId={setFundingAccountId}
                errorMessageByAccountId={errorMessageByAccountId}
                isDisabled={isSubmitting}
            />
        </OpenIraFlowStep>
    );
};

export default OpenIraFlowFundingStep;
